import {RoadKill} from "../RoadKill";
import {RoadKillUtils} from "../utils/RoadKillUtils";
import {RKHelper} from "../utils/RKHelper";
import {TimelineLite} from "gsap";

export class Split extends PIXI.spine.Spine {
    public readonly reelId: number;
    public readonly rowId: number

    constructor(reelId: number, rowId: number) {
        super(RoadKill.assetLoader.getSpineAsset("split"));
        this.reelId = reelId;
        this.rowId = rowId;
        this.name = "SPLIT_" + this.reelId + "_" + this.rowId;
        this.init();
    }

    public playIn(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.to(this, {duration: 0.1, alpha: 1});
        tl.add(RKHelper.playSpineWithTimeline(this, 0, "splitIn"));
        return tl;
    }

    public playOut(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(RKHelper.playSpineWithTimeline(this, 0, "splitOut"));
        tl.add(() => {
            this.visible = false;
        });
        return tl;
    }

    private init(): void {
        this.position = RoadKillUtils.getSymAbsolutePos(this.reelId, this.rowId);
        this.position.y += 15;
        this.alpha = 0;
    }
}